import { render, staticRenderFns } from "./PropostaTerapeuticaView.vue?vue&type=template&id=418f6b50"
import script from "./PropostaTerapeuticaView.vue?vue&type=script&lang=js"
export * from "./PropostaTerapeuticaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports